import { render, staticRenderFns } from "./UserNewMessage.vue?vue&type=template&id=2116e65a&"
import script from "./UserNewMessage.vue?vue&type=script&lang=js&"
export * from "./UserNewMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports